<template>
  <!--
    指定するもの
    - foldedByDefault: デフォルトで折りたたまれているかどうか

    TODO: PDFに対応する。何か入れたらURLを生成して、特別なタグと共に埋め込む&表示時にはPDFライブラリを使うとか？
    TODO: $routeでほぼほぼ自動で取れる様にし、必要に応じてpathを取得する様にする
  -->
  <div>
    <!-- loading -->
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="cyan px-4"
    ></v-progress-linear>

    <!-- viewer -->
    <div v-else-if="contentData.length>0">
      <div :class="classes" v-dompurify-html="contentData"></div>
      <!--↓撤去を検討-->
      <v-btn
        v-if="isAdmin && foldedByDefault && lidId !== 'home' && false"
        class="pa-0"
        @click="(add = true), (contentEditing = contentData)"
        icon
        :width="isSp ? '40px' : '80px'"
        :height="isSp ? '40px' : '80px'"
        :style="
          isSp
            ? 'position:absolute;margin-top:-40px;right:20px;background-color:#399942;'
            : 'position:absolute;margin-top:-80px;right:20px;background-color:#399942;'
        "
        ><v-icon :size="isSp ? 25 : 50" color="white"
          >mdi-pencil-plus</v-icon
        ></v-btn
      >
      <!-- 展開するボタン 画面中央 -->
      <div style="width: 100%" class="d-flex justify-center align-center">
        <v-btn
          v-if="foldingSetting && folded"
          class="mx-2"
          @click="folded = false"
          >もっと見る</v-btn
        >
        <v-btn v-if="foldingSetting && !folded" class="" @click="folded = true"
          >隠す</v-btn
        >
        <v-btn
          v-if="isAdmin && lidId !== 'home' && pageId !== 'content'"
          class="mx-2"
          @click="(add = true), (contentEditing = contentData)"
          >編集</v-btn
        >
      </div>
    </div>

    <!-- no content for admin (PC) -->
    <p v-else-if="isAdmin && !isSp" class="text-center mt-16 ink--text">
      管理者が自由に編集できるページです。<br />編集ボタンを押して、メンバーの皆さんに共有しましょう！
    </p>
    <!-- no content for admin (SP) -->
    <p v-else-if="isAdmin && isSp" class="text-center mt-16 ink--text">
      管理者が自由に編集できるページです。<br />編集ボタンを押して、メンバーの皆さんに共有しましょう！<br />（PCでの編集を推奨）
    </p>

    <div class="d-flex justify-center">
      <v-btn
        v-if="
          isAdmin &&
          !loading &&
          !contentData &&
          lidId !== 'home' &&
          pageId !== 'content'
        "
        class="mx-auto my-2"
        @click="(add = true), (contentEditing = contentData)"
        >編集</v-btn
      >
    </div>

    <!-- ホーム用・エディタ起動鉛筆 -->
    <div
      v-if="isAdmin && lidId === 'home'"
      style="
        height: 100px;
        position: fixed;
        bottom: 100px;
        right: 40px;
        z-index: 10;
      "
    >
      <v-fab-transition>
        <v-btn
          color="#707070"
          dark
          absolute
          right
          fab
          @click="(add = true), (contentEditing = contentData)"
        >
          <v-icon>mdi-pencil-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </div>

    <!-- アイデア・プロジェクト未登録時用・エディタ起動鉛筆    撤去検討 -->
    <v-btn
      v-if="
        !contentData && isAdmin && foldedByDefault && lidId !== 'home' && false
      "
      class="pa-0"
      @click="(add = true), (contentEditing = contentData)"
      icon
      width="40px"
      height="40px"
      style="
        position: absolute;
        margin-top: -40px;
        right: 34px;
        background-color: #399942;
      "
      ><v-icon size="25" color="white">mdi-pencil-plus</v-icon></v-btn
    >

    <!-- コンテンツページ用・エディタ起動鉛筆 -->
    <v-btn
      v-if="isAdmin && !foldedByDefault && pageId === 'content'"
      class="pa-0"
      @click="(add = true), (contentEditing = contentData)"
      icon
      width="80px"
      height="80px"
      style="
        position: fixed;
        bottom: 180px;
        right: 30px;
        background-color: #399942;
        z-index: 2;
      "
      ><v-icon size="50" color="white">mdi-pencil-plus</v-icon></v-btn
    >

    <!-- 実際のエディタ部分 -->
    <v-dialog
      v-if="isAdmin"
      v-model="add"
      width="80%"
      persistent
      :fullscreen="isSp"
      @keydown.esc="add = false"
    >
      <v-card height="95%">
        <v-card-actions>
          <quill-editor
            v-model="contentEditing"
            rows="6"
            :options="pjEditorOption"
            class="pt-0 ma-2"
            style="border: none; width: 100%"
            ref="quillEditor"
          >
          </quill-editor>
        </v-card-actions>
        <v-card-actions class="mt-8" style="">
          <v-spacer></v-spacer>
          <!-- 折りたたんで表示するかどうかのチェックボックス -->
          <v-checkbox
            v-if="foldedByDefault"
            v-model="userFoldingSetting"
            label="折りたたんで表示する"
            color="cyan"
            class="mr-4"
          ></v-checkbox>
          <v-btn class="mr-4" @click="add = false">キャンセル</v-btn>
          <v-btn
            class="mr-4"
            @click="submitContent(), (add = false)"
            >確定</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import VueDOMPurifyHTML from "vue-dompurify-html";
Vue.use(VueDOMPurifyHTML, {
  default: {
    ADD_TAGS: ["iframe"], // this one whitelists Youtube
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"]
  },
});
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";
import ResizeModule from "@ssumo/quill-resize-module";
Quill.register('modules/resize', ResizeModule)
import VueMq from "vue-mq";
Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    sp: 959,
    pc: 960,
  },
  defaultBreakpoint: "pc", // customize this for SSR
});
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

export default {
  name: "contentViewAndEditor",
  props: ["lidId", "pageType", "foldedByDefault"],
  data: () => ({
    loading: true,
    contentData: "",
    contentEditing: "",
    add: false,
    folded: true,
    userFoldingSetting: false,
    pjEditorOption: {
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          //[{ 'font': [] }],
          //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          ["bold", "italic", "underline", "strike"], // toggled buttons
          //['blockquote', 'code-block'],
          //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
          //[{ 'list': 'ordered'}, { 'list': 'bullet' }],
          //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ align: [] }],
          ["link"],
          //['clean']
          ["image", "video"], // remove formatting button
        ],
        resize: {
          locale: {
            altTip: "altキーを押しながらドラッグすると比率を維持して拡大縮小できます",
            floatLeft: "左寄せ",
            floatRight: "右寄せ",
            center: "中央寄せ",
            restore: "元に戻す",
          }
        }
      },
      placeholder: "ここに入力してください",
    },
  }),
  components: {
    quillEditor,
  },
  created() {
    this.getContent();
    window.addEventListener("beforeunload", this.confirmSave);
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.confirmSave);
  },
  watch: {
    contentData: function () {
      this.loading = false;
    },
    userFoldingSetting: function () {
      console.log("setUserFoldingSetting", typeof this.userFoldingSetting);
    },
  },
  computed: {
    pageId() {
      return this.pageType.startsWith("sp_")
        ? this.pageType.slice(3)
        : this.pageType;
    },
    foldingSetting() {
      return this.foldedByDefault && this.userFoldingSetting;
    },
    isSp() {
      return this.$mq === "sp";
    },
    classes() {
      return {
        "mx-4 mt-2 qimg": true,
        folded: this.folded && this.foldingSetting,
        "folder::before": this.folded && this.foldingSetting,
      };
    },
    isAdmin() {
      return !this.isSp && (this.$store.state.isAdmin||(this.aboutLid&&this.aboutLid.lidAdmin&&this.aboutLid.lidAdmin.includes(this.$store.state.auth?.user?.uid || '')))
    },
    lid() {
      return this.$store.state.lid;
    },
    alid() {
      return this.$store.state.alid;
    },
    aboutLid() {
      return this.$store.state.aboutLid
    },
  },
  methods: {
    confirmSave(event) {
      if (this.contentEditing.length > 0) {
        event.returnValue = "このページから移動しますか？";
      }
    },
    textConverter (text) {
      return text
        .replaceAll("width=", "max-width='100%' width=")
        .replaceAll('class="ql-align-center"', 'class="ql-align-center" style="text-align: center;"')
        .replaceAll('class="ql-align-right"', 'class="ql-align-right" style="text-align: right;"')
        .replaceAll('class="ql-align-justify"', 'class="ql-align-justify" style="text-align: justify;"')
        .replaceAll(`<p>`, `<p style="margin-bottom:0">`)
        // aタグのうち、中身がテキストのものは外部リンクである表示を追加。imgタグは無視
        .replace(/<a href="https?:\/\/(?!localhost)(.+?)".*?>([^<img].+?)<\/a>/g, (match, p1, p2) => {
          return `<a href="https://${p1}" target="_blank" rel="noopener noreferrer">${p2}<span class="mdi mdi-open-in-new"></span></a>`;
        })
        .replace(/<iframe.*?style="(.+?)".*?<\/iframe>/g, (match, p1) => {
          return match.replace(p1, `${p1}; aspect-ratio: 16 / 9 !important; max-width: 100%;`);
        })
        .replace(/<img.*?style="(.+?)".*?>/g, (match, p1) => {
          return match.replace(p1, `${p1}; max-width: 100%;`);
        })
    },
    getContent: async function () {
      const self = this;
      let getD = true;
      const filepath = `contents/${this.lidId || "home"}/${this.pageId}.html`;
      // console.log(filepath)
      const ref = await firebase.storage().ref(filepath);

      if (this.lidId !== "home") {
        //各Lid
        getD = true;
      } else {
        //Home
        if (
          this.pageId == "zentei" &&
          typeof this.$store.state.config.home_preinfoTime == "object"
        ) {
          console.log(typeof this.$store.state.config.home_preinfoTime);
          getD = true;
        }
        if (
          this.pageId == "news" &&
          typeof this.$store.state.config.home_newsTime == "object"
        ) {
          console.log(typeof this.$store.state.config.home_newsTime);
          getD = true;
        }
      }

      if (getD) {
        // ダウンロードURLを取得
        await ref
          .getDownloadURL()
          .then((downloadLink) => {
            this.axios.get(downloadLink).then((res) => {
              self.contentData = this.textConverter(res.data)
            });
          })
          .catch((error) => {
            console.error(error);
          });
        ref.getMetadata().then((metadata) => {
          this.userFoldingSetting =
            metadata.customMetadata.foldedByDefault == "true";
          this.passUpdatedTime(metadata.updated);
        });
      }
      self.loading = false;
    },
    submitContent() {
      this.contentEditing = "<div>" + this.contentEditing + "</div>";
      try {
        const self = this;
        const filepath = `contents/${this.lidId || "home"}/${this.pageId}.html`;
        const ref = firebase.storage().ref(filepath);
        ref.putString(this.contentEditing).then((snapshot) => {
          this.passUpdatedTime(snapshot.metadata.updated);
          snapshot.ref.updateMetadata({
            customMetadata: {
              foldedByDefault: this.userFoldingSetting ? "true" : "false",
            },
          });
        });
        this.contentData = this.textConverter(this.contentEditing);
        this.contentEditing = "";
        let collection = firebase.firestore().collection("0").doc("config");
        if (this.lidId !== "home" && this.pageId == "content") {
          self.$store.dispatch("setConfigNotify", {
            title: `Lid${self.$t("前提情報")}更新`,
            content: `Lid:${self.aboutLid.title}の${self.$t(
              "前提情報"
            )}が更新されました。`,
            address: "all",
            type: 7,
            lidid: self.lidId,
            tag: "Lid",
          });
          self.$store.dispatch("setLidNotify", {
            title: `Lid${self.$t("前提情報")}更新`,
            content: `Lid:${self.aboutLid.title}の${self.$t(
              "前提情報"
            )}が更新されました。`,
            address: "all",
            type: 7,
            lidid: self.lidId,
            tag: "Lid",
          });
          collection = firebase.firestore().collection("0").doc(self.lidId);
          collection
            .set(
              {
                updatedAt_preinfo:
                  firebase.firestore.FieldValue.serverTimestamp(),
              },
              { merge: true }
            )
            .then(function (docRef) {
              // 保存に成功した時
              console.log("Document written with ID: ");
              self.$store.dispatch("setLidTime", {
                lidId: self.lidId,
                date: firebase.firestore.Timestamp.fromDate(new Date()),
              });
            })
            .catch(function (error) {
              // 保存に失敗した時
              console.error("Error adding document:", error);
            });
        } else if (this.pageId == "news") {
          self.$store.dispatch("setConfigNotify", {
            title: `お知らせ更新`,
            content: `お知らせが更新されました。`,
            address: "all",
            type: 0,
            tag: "全体",
          });
          collection
            .set(
              {
                home_newsTime: firebase.firestore.FieldValue.serverTimestamp(),
              },
              { merge: true }
            )
            .then(function (docRef) {
              // 保存に成功した時
              console.log("Document written with ID: ");
              self.$store.dispatch("setHomeTime", {
                type: self.pageId,
                date: firebase.firestore.Timestamp.fromDate(new Date()),
              });
            })
            .catch(function (error) {
              // 保存に失敗した時
              console.error("Error adding document:", error);
            });
        } else if (this.pageId == "zentei") {
          self.$store.dispatch("setConfigNotify", {
            title: `前提情報更新`,
            content: `前提情報が更新されました。`,
            address: "all",
            type: 1,
            tag: "全体",
          });
          collection
            .set(
              {
                home_preinfoTime:
                  firebase.firestore.FieldValue.serverTimestamp(),
              },
              { merge: true }
            )
            .then(function (docRef) {
              // 保存に成功した時
              console.log("Document written with ID: ");
              self.$store.dispatch("setHomeTime", {
                type: self.pageId,
                date: firebase.firestore.Timestamp.fromDate(new Date()),
              });
            })
            .catch(function (error) {
              // 保存に失敗した時
              console.error("Error adding document:", error);
            });
        }
      } catch (error) {
        //alert("エラーが発生しました。恐れ入りますがもう一度操作をやり直してみてください。")
        console.error("Error adding content:", error);
      }
    },
    passUpdatedTime(updated) {
      const jpOffset = new Date().getTimezoneOffset() + 9 * 60;
      const japaneseDate = new Date(new Date(updated) + jpOffset * 60 * 1000);
      const beautifiedDate = japaneseDate.toLocaleString("ja-JP", {
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
      this.$emit("updateDate", beautifiedDate);
    },
  },
};
</script>
<style scoped>
.cloud {
  color: #707070;
}
.folded {
  position: relative;
  overflow: hidden;
  max-height: 55vh;
  padding-bottom: 30px;
}
.folded::before {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  content: "";
  height: 50px;
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.8) 50%,
    #fff 100%
  );
  background: linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.8) 50%,
    #fff 100%
  );
}

.qimg > div > p > img {
  max-width: 100% !important;
  height: auto !important;
}
.qimg > div > h2 > img {
  max-width: 100% !important;
  height: auto !important;
}
.qimg >>> img {
  max-width: 100% !important;
  height: auto !important;
}
</style>
